<template>
    <div>
        <v-tour name="EditShopTour" :steps="steps" :callbacks="callbacks"></v-tour>
    </div>
</template>

<script>
import { inject } from 'vue'
export default {
    name: 'EditShopTour',
    setup() {

        return {
        }
    },
    data() {
        return {
            steps: [
                {
                    target: '.v-step-1',  // We're using document.querySelector() under the hood
                    header: {
                        title: this.$t('shop.wizard.steps.data.title'),
                    },
                    content: this.$t('shop.wizard.steps.data.content'),
                    before: () => {
                    },
                    params: {
                        highlight: true,
                        enableScrolling: false
                    }
                },
                {
                    target: '.v-step-2',  // We're using document.querySelector() under the hood
                    header: {
                        title: this.$t('shop.wizard.steps.logo.title'),
                    },
                    content: this.$t('shop.wizard.steps.logo.content'),
                    // content: `Über dieses Zahnrad können Sie das Protokoll der Prüfung anfordern und sich abmelden`,
                    before: () => {
                        // Call the fetchData method from this component
                    },
                    params: {
                        highlight: true,
                        highlightPadding: 10,
                        enableScrolling: false,
                        placement: 'right'
                    }
                },
                {
                    target: '.v-step-3',  // We're using document.querySelector() under the hood
                    header: {
                        title: this.$t('shop.wizard.steps.gallery.title'),
                    },
                    content: this.$t('shop.wizard.steps.gallery.content'),
                    // content: `Hierrüber können sie einerseits die Kacheln der Studierenden aus und einblenden und sortieren. Zusätzlich können Sie zwischen der Kameraansicht und der Bildschirmansicht der Studierenden wechseln.`,
                    before: () => {
                        // Call the fetchData method from this component
                        // console.log(this.showBackdrop);

                        localStorage.setItem('editShopTourStep', 3);
                        this.$tours['EditShopTour'].stop();
                        this.BackdropHeader = false;
                        this.BackdropSideBar = false;
                        this.showBackdrop = false;
                    },
                    params: {
                        highlight: true,
                        highlightPadding: 10,
                        placement: 'left',
                        enableScrolling: false,
                    }
                },
                {
                    // VERIFY
                    target: '.v-step-4',  // We're using document.querySelector() under the hood
                    header: {
                        title: this.$t('shop.wizard.steps.openingTimes.title'),
                    },
                    content: this.$t('shop.wizard.steps.openingTimes.content'),
                    // content: `Nachdem der Studierende mit der Identifikation fertig sind wird Ihnen ein Oranger Sticker an der Kachel angezeigt, durch Klick auf die Kachel gelangen sie auf folgende Oberfläche auf der Sie sowohl ein Bild des Studenten als auch ein Bild eines ID Dokuments sehen. Nach Abgleich der Bilder können Sie den Studierenden verifizieren oder ablehnen. Wodurch er aufgefordert wird neue Bilder zu machen.`,
                    before: async () => {
                        // Call the fetchData method from this component
                        // console.log(this.showBackdrop);
                        window.scrollTo(0, 0);
                        await this.waitForStep();
                    },
                    params: {
                        highlight: true,
                        highlightPadding: 10,
                        // placement: 'left',
                        enableScrolling: false,
                    }
                },
                {
                    // OVERVIEW
                    target: '.v-step-5',  // We're using document.querySelector() under the hood
                    header: {
                        title: this.$t('shop.wizard.steps.productCategory.title'),
                    },
                    content: this.$t('shop.wizard.steps.productCategory.content'),
                    // content: `Overview`,
                    before: async () => {
                        // Call the fetchData method from this component
                        // console.log(this.showBackdrop);
                        await this.waitForStep();
                        // window.scrollTo(0, 0);
                    },
                    params: {
                        highlight: true,
                        highlightPadding: 10,
                        placement: 'left'
                    }
                },
                {
                    //REPORT
                    target: '.v-step-6',  // We're using document.querySelector() under the hood
                    header: {
                        title: this.$t('shop.wizard.steps.tags.title'),
                    },
                    content: this.$t('shop.wizard.steps.tags.content'),
                    // content: `Report Student`,
                    before: async () => {

                        await this.waitForStep();
                        // window.scrollTo(0, 0);
                    },
                    params: {
                        highlight: true,
                        highlightPadding: 10,
                        placement: 'right'
                    }
                },
                {
                    // PROCTORS
                    target: '.v-step-7',  // We're using document.querySelector() under the hood
                    header: {
                        title: this.$t('shop.wizard.steps.submit.title'),
                    },
                    content: this.$t('shop.wizard.steps.submit.content'),
                    // content: `Supervisors`,
                    before: async () => {

                        window.scrollTo(0, 0);
                        await this.waitForStep();
                    },
                    params: {
                        highlight: true,
                        highlightPadding: 10,
                        enableScrolling: false,
                    }
                },
            ],

            callbacks: {
                onStop: this.OnTourStop,
                onFinish: this.OnTourFinish,
                onSkip: this.OnTourSkip,
            }
        }
    },
    mounted: function () {
        const savedStep = parseInt(localStorage.getItem('editShopTourStep'));
        if(savedStep !== 3){
            localStorage.removeItem('editShopTourStep'); // Clear it
        }
        if (!isNaN(savedStep)) {
            localStorage.removeItem('editShopTourStep'); // Clear it
            this.$nextTick(() => {
                this.$tours['EditShopTour'].start(savedStep-1);
            });
        }
    },
    methods: {
        startTour() {
            this.$tours['EditShopTour'].start();
        },
        OnTourStop(currentStep) {
            //   window.location.reload();
        },
        OnTourFinish(currentStep) {
            
        },
        OnTourSkip(currentStep) {
            localStorage.removeItem('editShopTourStep');
        },
        waitForStep() {
            return new Promise((resolve) => {
                // You can add more logic here if you want to check for certain conditions
                setTimeout(resolve, 100);  // Just wait for 100ms for now
            });
        }
    }
}
</script>